import React from 'react';
import styled from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import loadable from '@loadable/component';
import useBellaTranslator from 'Client/hooks/useTranslator';

export type CountryCode = 'At' | 'Be' | 'Ch' | 'Cz' | 'De' | 'Es' | 'Fr' | 'It' | 'Nl' | 'Pl' | 'Sk';

const redirectedCountryCodes = {
    At: 'De',
    Be: 'Fr',
    Ch: 'De',
};

export type ClimateLogoProps = {
    countryCode: CountryCode;
    color?: string;
    width?: number;
    height?: number;
};

// Explicit index.js importing is necessary because loadable full dynamic import relies on webpack
// dynamic importing, which by default tries to import and bundle on build everything in related folder
// including map files. However webpack does not have loaders for map files, which causes errors.
const Logo = loadable(
    (props: ClimateLogoProps) =>
        import(`@westwing/ui-kit/ClimateNeutralLogo/CountryLogos/${props.countryCode}/index.js`)
);

const StyledWrapper = styled.div`
    padding: 0 0 20px;
    ${forDesktop`
        padding: 4px 0 0;
    `}
`;

const ClimateNeutralLogo = ({
    countryCode,
    color = '#000000',
    width = 149,
    height = 40,
}: ClimateLogoProps): React.ReactElement => {
    const code = redirectedCountryCodes[countryCode] || countryCode;
    const t = useBellaTranslator();
    const carbonNeutral = t('carbon_neutral');

    return (
        <StyledWrapper>
            {/* eslint-disable-next-line react/forbid-elements */}
            <a
                aria-label={carbonNeutral}
                href="https://fpm.climatepartner.com/tracking/15139-2111-1001/en?utm_source=(direct)&utm_medium=climatepartner.com"
            >
                <Logo countryCode={code} color={color} width={width} height={height} aria-hidden="true" />
            </a>
        </StyledWrapper>
    );
};

export default ClimateNeutralLogo;
